// Generated file. To retain edits, remove this comment.
// Generated file. To retain edits, remove this comment.
import { getPipelineWorkerUrl as itkWasmGetPipelineWorkerUrl } from 'itk-wasm';
let pipelineWorkerUrl;
// Use the version shipped with an app's bundler
const defaultPipelineWorkerUrl = null;
export function setPipelineWorkerUrl(workerUrl) {
    pipelineWorkerUrl = workerUrl;
}
export function getPipelineWorkerUrl() {
    if (typeof pipelineWorkerUrl !== 'undefined') {
        return pipelineWorkerUrl;
    }
    const itkWasmPipelineWorkerUrl = itkWasmGetPipelineWorkerUrl();
    if (typeof itkWasmPipelineWorkerUrl !== 'undefined') {
        return itkWasmPipelineWorkerUrl;
    }
    return defaultPipelineWorkerUrl;
}
//# sourceMappingURL=pipeline-worker-url.js.map